export default __webpack_public_path__ + "static/media/480_business04-it-mobile.e721e1cd.png";